"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCrewMemberProperty = exports.crewMemberPropertyDefinition = void 0;
exports.crewMemberPropertyDefinition = {
    view: { label: 'Crew Member' },
    constraints: [
        {
            name: 'stencils',
            argument: ['rally-driver'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'crew-member',
};
const isCrewMemberProperty = (prop) => {
    return prop.name === exports.crewMemberPropertyDefinition.name;
};
exports.isCrewMemberProperty = isCrewMemberProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3Jldy1tZW1iZXIucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9jcmV3LW1lbWJlci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDRCQUE0QixHQUFHO0lBQzFDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxhQUFhLEVBQUU7SUFDOUIsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxjQUFjLENBQUM7U0FDM0I7S0FDRjtJQUNELElBQUksRUFBRSxPQUFPO0lBQ2IsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsYUFBYTtDQUNZLENBQUE7QUFJMUIsTUFBTSxvQkFBb0IsR0FBRyxDQUFDLElBQWtCLEVBQThCLEVBQUU7SUFDckYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG9DQUE0QixDQUFDLElBQUksQ0FBQTtBQUN4RCxDQUFDLENBQUE7QUFGWSxRQUFBLG9CQUFvQix3QkFFaEMifQ==